import React from "react";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";

export const CookieConsentBanner = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Aceptar"
      declineButtonText="Rechazar"
      cookieName="educajob.net"
      style={{ background: "#2B373B" }}
      buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
      expires={150}
      onDecline={() => {
        alert("Declinas las cookies.");
      }}
    >
      Usamos cookies para mejorar la experiencia del usuario.{" "}
      <Link to="/politica-de-cookies" style={{ color: "#FFD700" }}>
        Políticas de Cookies
      </Link>
    </CookieConsent>
  );
};
